/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientPutOTCMedicineHiddenBodyTypename = "PatientPutOTCMedicineHiddenBody" as const;

/**
 *
 * @export
 * @interface PatientPutOTCMedicineHiddenBody
 */
export interface PatientPutOTCMedicineHiddenBody {
  /**
   *
   * @type {boolean}
   * @memberof PatientPutOTCMedicineHiddenBody
   */
  hidden: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientPutOTCMedicineHiddenBody
   */
  readonly __typename?: string;
}

export function PatientPutOTCMedicineHiddenBodyFromJSON(json: any): PatientPutOTCMedicineHiddenBody {
  return PatientPutOTCMedicineHiddenBodyFromJSONTyped(json, false);
}

export function PatientPutOTCMedicineHiddenBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientPutOTCMedicineHiddenBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientPutOTCMedicineHiddenBodyTypename,

    hidden: json["hidden"],
  };
}

export function PatientPutOTCMedicineHiddenBodyToJSON(object?: PatientPutOTCMedicineHiddenBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    hidden: value.hidden,
  };
}
